import { api } from './api'
import { RolePermission, Permission } from '../types/rolePermission'
import { PermissionTemplate } from '../types/rolePermission'
import { UserRole } from '../types/user'

export const rolePermissionService = {
  /**
   * Get all role permissions
   */
  getAll: async (): Promise<RolePermission[]> => {
    const response = await api.get<RolePermission[]>('/role-permissions')
    return response.data
  },

  /**
   * Get permissions for a specific role
   */
  getByRole: async (role: UserRole): Promise<RolePermission> => {
    const response = await api.get<RolePermission>(`/role-permissions/${role}`)
    return response.data
  },

  /**
   * Update permissions for a role
   */
  update: async (role: UserRole, permissions: Permission[]): Promise<RolePermission> => {
    const response = await api.put<RolePermission>(`/role-permissions/${role}`, { permissions })
    return response.data
  },

  /**
   * Get available permission templates
   */
  getTemplates: async (): Promise<PermissionTemplate[]> => {
    const response = await api.get<PermissionTemplate[]>('/permission-templates')
    return response.data
  },

  /**
   * Apply a permission template to a role
   */
  applyTemplate: async (role: UserRole, templateName: string): Promise<RolePermission> => {
    const response = await api.post<RolePermission>(`/role-permissions/${role}/apply-template`, {
      templateName,
    })
    return response.data
  },
}
